/** Per-channel FlatList `key` combining channel id and optional remount fragment. */
const getEpgChannelProgramListKey = (
  channelId: string,
  programListRemountKey: string | null,
): string =>
  programListRemountKey != null
    ? `${channelId}-${programListRemountKey}`
    : channelId;

export default getEpgChannelProgramListKey;
